var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerIconGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 0V7H6.5V0H5.5Z",
    fill: "#696565"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 7.81244C1 5.93059 2.03942 4.29082 3.57785 3.43714L3.09264 2.56274C1.24937 3.58557 0 5.55276 0 7.81244C0 11.1262 2.68629 13.8124 6 13.8124C9.31371 13.8124 12 11.1262 12 7.81244C12 5.59097 10.7925 3.65212 9.00036 2.61544L8.49964 3.48105C9.99545 4.34633 11 5.96237 11 7.81244C11 10.5739 8.76142 12.8124 6 12.8124C3.23858 12.8124 1 10.5739 1 7.81244Z",
    fill: "#696565"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerIconGray);
export default __webpack_public_path__ + "static/media/powerIconGray.28fbeda283c1ef99b6d50525e4f30a1f.svg";
export { ForwardRef as ReactComponent };